// Display helpers for the order details page

// Lookup models expose nameTranslated / name / title depending on the table
export const label = obj => obj?.nameTranslated || obj?.name || obj?.title || "";

export const money = value =>
  value === null || value === undefined || value === "" ? "-" : Number(value).toFixed(2);

export const statusColor = statusId => {
  if (statusId == 7) return "danger";
  if (statusId == 6) return "success";
  if (statusId == 13) return "warning";
  return "primary";
};

// Statuses where the dashboard can't move the order or change its driver
export const FINAL_STATUSES = [6, 7, 13];

export const mapsLink = address =>
  address?.latitude && address?.longitude
    ? `https://www.google.com/maps?q=${address.latitude},${address.longitude}`
    : null;
